import {FC, memo} from "react";
import {ComplectationsSectionProps} from "./ComplectationsSection-types";
import {Body, Head, Icon, Root, Title, Toggler} from "./ComplectationsSection-styles";
import {useToggle} from "../../hooks/useToggle";
import SectionVariants from "../SectionVariants/SectionVariants";
import SectionTabs from "../SectionTabs/SectionTabs";
import {ComplectationAttributeType} from "../../data";
import {useOptionsByAttribute} from "../../hooks/useOptionsByAttribute";


/**
 * Атрибуты глобальной группы
 * Например: логотип основы, цвет основы, цвет ремня и т.п.
 *
 * Данный компонент выводит варианты для выбора значения атрибута
 *
 * TODO: Изменить isCollapsed на обратную логику
 */
const ComplectationsSection: FC<ComplectationsSectionProps> = memo((props) => {
    const {uid, block, attribute, onOptionSelect, isVisibleOnMobile} = props;

    const {isEnabled, onEnabledToggle} = useToggle(true);

    const options = useOptionsByAttribute(block.items, attribute.id);

    return (
        <Root $isVisibleOnMobile={isVisibleOnMobile}>
            {
                attribute.title &&
                <Head onClick={onEnabledToggle}>

                    <Title>{attribute.title}</Title>

                    <Toggler $isCollapsed={!isEnabled}>
                        <Icon $isCollapsed={!isEnabled}/>
                    </Toggler>

                </Head>
            }

            <Body $isCollapsed={!isEnabled}>
                {
                    attribute.type === ComplectationAttributeType.select &&
                    <SectionVariants uid={uid} options={options} onOptionSelect={onOptionSelect}/>
                }
                {
                    attribute.type === ComplectationAttributeType.tabs &&
                    <SectionTabs uid={uid} options={options} groups={block.groups} onOptionSelect={onOptionSelect}/>
                }
            </Body>
        </Root>
    );
});

export default ComplectationsSection;
